import React from "react";
import { observer } from "mobx-react";
import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import LeadListing from "@components/Main/Pro/LeadListing";

const ProLatestLeads = observer(({ h2, job }) => {
	const classes = useStyles("Pro");

	const { recentHeader } = useConstants("ProBannerViewModel");

	return (
		<Box
			component="section"
			className={classes.hiwWrapper}
			display={"flex"}
			alignItems={"center"}
			justifyContent={"center"}
			bgcolor={"grey.50"}
		>
			<Container maxWidth={false} className={classes.proContainer}>
				<h2 className={classes.joinH2}>{h2 ? h2 : recentHeader}</h2>

				<LeadListing job={job} />
			</Container>
		</Box>
	);
});

export default ProLatestLeads;
